import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface SellerOnboardingSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoDashboard: () => void;
  onUploadDocs: () => void;
}

const SellerOnboardingSuccessModal: React.FC<SellerOnboardingSuccessModalProps> = ({ isOpen, onClose, onGoDashboard, onUploadDocs }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.85, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 10 }}
            transition={{ type: 'spring', stiffness: 260, damping: 22 }}
          >
            <div className="flex items-start justify-between mb-4 gap-3">
              <div className="flex items-center gap-3">
                <motion.div
                  initial={{ scale: 0, rotate: -45 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ type: 'spring', stiffness: 280, damping: 14, delay: 0.15 }}
                  className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0"
                >
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600"></i>
                </motion.div>
                <motion.h2
                  initial={{ opacity: 0, x: -8 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.25, duration: 0.3 }}
                  className="text-xl md:text-2xl font-semibold leading-tight"
                >
                  Application successfully submitted! 🎉
                </motion.h2>
              </div>
              <button className="text-gray-500 hover:text-gray-700" onClick={onClose} aria-label="Close">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <motion.p
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.3 }}
              className="text-gray-600 mb-5"
            >
              Your seller application is in admin review — we’ll let you know within 24 hours. In the meantime, you can browse the marketplace or head to your dashboard.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.3 }}
              className="flex flex-col gap-3"
            >
              <button className="px-4 py-2.5 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-xl hover:opacity-95 transition-opacity font-medium shadow-lg shadow-teal-500/20" onClick={onGoDashboard}>
                Go to Seller Dashboard
              </button>
              <button className="px-4 py-2.5 border border-gray-300 text-gray-800 rounded-xl hover:bg-gray-50 transition-colors" onClick={onUploadDocs}>
                Go to Document Upload
              </button>
              <button className="px-4 py-2 text-gray-500 hover:text-gray-700 text-sm" onClick={onClose}>Okay</button>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SellerOnboardingSuccessModal;